import type { SolMemorySourceCard as SolMemorySourceCardData } from '../../data/sol/sol-contract';
import { formatInstant } from '../../lib/timezone';

/**
 * One cited LONG-TERM MEMORY — something he asked Sol to remember.
 *
 * **IT IS NOT A RECORD, AND IT MUST NOT LOOK LIKE ONE.** Every other card on
 * this screen points at something Crewlink holds and can be reopened. This one
 * points at a sentence he said once. Presenting it with the same weight as a
 * Capture would be the product telling a small lie about where an answer came
 * from — so it says REMEMBERED, plainly, and carries no "open" affordance
 * because there is nothing to open.
 *
 * **THE DATE IS NOT DECORATION.** A memory is a snapshot, and how old it is
 * changes how much it should be trusted: "ABC Electric handles temporary
 * power", said last week, reads differently from the same words said two years
 * ago. A current Crewlink record always outranks it either way.
 */
export interface SolMemorySourceCardProps {
  readonly card: SolMemorySourceCardData;
  readonly timeZone: string | null;
}

export function SolMemorySourceCard({ card, timeZone }: SolMemorySourceCardProps) {
  const saved = timeZone ? formatInstant(card.savedAt, timeZone, { dateStyle: 'medium' }) : '';

  return (
    <div className="sol-source sol-source--memory">
      <span className="sol-source-head">
        <span className="sol-source-title">Remembered</span>
        <span className="sol-source-status">MEMORY</span>
      </span>
      {saved ? <span className="sol-source-meta">{`Saved ${saved}`}</span> : null}
      <span className="sol-source-caption">{card.content}</span>
    </div>
  );
}
